import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner"
export default function OneSubscriberModal({
  cancelModal,
  selectedSub,
  ConvertToCurrency,
  cancelFromOneSub,
  selectStripeSub
}) {
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(true);
  const [stripeSub,setStripeSub] = useState(null)

 

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const stripeSubResponse = await axios.get(`${ApiConnectionString}/stripe/subscription/${selectedSub.id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (stripeSubResponse.status === 200) {
        setStripeSub(stripeSubResponse.data);
        selectStripeSub(stripeSubResponse.data)
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
fetchData()
  },[])
  

  if (isLoading || !stripeSub) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>{" "}
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20">Subscription</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>

          <table>
            <tbody>
              <tr>
                <td className="red-text fw-bold">
                  <label>Customer:</label>
                </td>
                <td><p>{stripeSub.viewAppUser.username}</p></td>
              </tr>
              <tr>
                <td className="red-text fw-bold">
                  <label>Profile:</label>
                </td>
                <td>
                  <p>
                    {selectedSub.viewBookingProfile.firstName}{" "}
                    {selectedSub.viewBookingProfile.lastName} (
                    {selectedSub.viewBookingProfile.username})
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="red-text fw-bold">Subscription:</label>
                </td>
                <td>
                  <p>{selectedSub.viewProduct.name}</p>
                </td>
              </tr>

              <tr>
                <td>
                  <label className="red-text fw-bold">Cost:</label>
                </td>
                <td>
                  <p>
                  {" "}
                  {ConvertToCurrency.format(selectedSub.viewProduct.price / 100)} per{" "}
                  {selectedSub.viewProduct.interval}
                </p>
                </td>
              </tr>
              <tr>
                <td>
                  <label className="red-text fw-bold">Member Since:</label>
                </td>
                <td><p>{new Date(stripeSub.created).toLocaleDateString()}</p></td>
              </tr>
              <tr>
                <td>
                  <label className="red-text fw-bold">Status:</label>
                </td>
                <td>
                  {stripeSub.cancelPending ? (
                    <p className="text-danger">
                      Cancled, this will end on{" "}
                      {new Date(stripeSub.endPeroidDate).toLocaleDateString()}
                    </p>
                  ) : (
                    <p className="text-success">Active</p>
                  )}
                </td>
              </tr>
              <tr>
                <td>
                  <label className="red-text fw-bold">Next Payment Due:</label>
                </td>

                {stripeSub.cancelPending ? (
                <p>none</p>
              ) : (
                <p>{new Date(stripeSub.nextPayDate).toLocaleDateString()}</p>
              )}
              </tr>
            </tbody>
          </table>

        {!stripeSub.cancelPending &&  <button onClick={cancelFromOneSub} className="delete-button">
            Cancel Subscription
          </button>}
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
}
